import React from 'react';
import { FONT_FAMILIES } from '../../lib/section-appearance';

/** Appearance options for the inverted section: colours, font, B/I/U, title, grid, legend position. */
export default function SectionAppearanceControls({ appearance: a, onChange, onReset, C, selStyle, lbl }) {
  const row = { display: 'flex', alignItems: 'center', gap: 6, fontSize: 10, color: C.text2 };
  const tog = (key, label, extra) => (
    <button type="button" data-testid={`appearance-${key}`} aria-pressed={!!a[key]} title={key}
      onClick={() => onChange({ [key]: !a[key] })}
      style={{ width: 26, padding: '3px 0', borderRadius: 6, cursor: 'pointer', fontSize: 11, ...extra,
        background: a[key] ? C.bg4 : 'transparent', color: a[key] ? C.accent : C.text2,
        border: `1px solid ${a[key] ? C.accentBorder : C.border}` }}>{label}</button>
  );
  const color = (key, label, testid) => (
    <label style={{ ...row, flex: 1 }}>
      <input type="color" data-testid={testid} value={a[key]} aria-label={label}
        onChange={e => onChange(key === 'plotBg' ? { plotBg: e.target.value, frameBg: e.target.value } : { [key]: e.target.value })}
        style={{ width: 24, height: 20, padding: 0, border: 'none', background: 'none' }} />
      {label}
    </label>
  );
  return (
    <>
      <div style={{ ...lbl, marginTop: 4, fontWeight: 700 }}>Appearance</div>
      <div style={{ display: 'flex', gap: 6 }}>
        {color('plotBg', 'Background', 'appearance-bg')}
        {color('textColor', 'Text', 'appearance-text')}
      </div>
      <div style={{ display: 'flex', gap: 4 }}>
        <select data-testid="appearance-font" aria-label="Font family" value={a.fontFamily}
          onChange={e => onChange({ fontFamily: e.target.value })} style={{ ...selStyle, flex: 1, boxSizing: 'border-box' }}>
          {FONT_FAMILIES.map(f => <option key={f} value={f}>{f}</option>)}
        </select>
        <input type="number" data-testid="appearance-size" aria-label="Font size" min={8} max={18} value={a.fontSize}
          onChange={e => onChange({ fontSize: Math.max(8, Math.min(18, parseInt(e.target.value, 10) || 11)) })}
          style={{ ...selStyle, width: 44, boxSizing: 'border-box' }} />
      </div>
      <div style={{ display: 'flex', gap: 4 }}>
        {tog('bold', 'B', { fontWeight: 700 })}
        {tog('italic', 'I', { fontStyle: 'italic' })}
        {tog('underline', 'U', { textDecoration: 'underline' })}
      </div>
      <input type="text" data-testid="appearance-title" placeholder="Title (blank = model name)" value={a.titleText}
        onChange={e => onChange({ titleText: e.target.value })} style={{ ...selStyle, boxSizing: 'border-box' }} />
      <label style={{ ...row, cursor: 'pointer' }}>
        <input type="checkbox" data-testid="appearance-show-title" checked={a.showTitle}
          onChange={e => onChange({ showTitle: e.target.checked })} style={{ accentColor: C.accent }} /> Show title
      </label>
      <label style={{ ...row, cursor: 'pointer' }}>
        <input type="checkbox" data-testid="appearance-grid" checked={a.showGrid}
          onChange={e => onChange({ showGrid: e.target.checked })} style={{ accentColor: C.accent }} /> Show grid
      </label>
      <label style={row}>Legend
        <select data-testid="appearance-legend" value={a.legendPosition} onChange={e => onChange({ legendPosition: e.target.value })}
          style={{ ...selStyle, flex: 1, boxSizing: 'border-box' }}>
          <option value="right">right</option>
          <option value="bottom">bottom</option>
        </select>
      </label>
      <button type="button" data-testid="appearance-reset" onClick={onReset}
        style={{ fontSize: 10, padding: '5px', borderRadius: 6, background: C.bg4, color: C.text1, border: `1px solid ${C.border}`, cursor: 'pointer' }}>
        Reset to theme default
      </button>
    </>
  );
}
